<template>
  <v-container fluid>
    <v-form v-model="valid">
      <v-card>
        <v-card-title>
          <span class="headline mb-0">権限詳細</span>
        </v-card-title>
        <v-card-actions>
          <v-btn
            :disabled="!valid"
            @click="save"
            v-permit.SHARP_AUTHORITY_NEW
            >{{ $t('app.buttons.save') }}</v-btn
          >
          <v-btn @click="$router.go(-1)">{{ $t('app.buttons.back') }}</v-btn>
        </v-card-actions>
        <v-container fluid>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                disabled
                label="権限グループCD"
                v-model="form.roleCode"
              />
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex md3 sm6 xs12>
              <v-text-field
                clearable
                disabled
                label="権限グループ名"
                v-model="form.roleName"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <v-card class="mt-2">
        <v-card-title>詳細情報</v-card-title>
        <v-container fluid>
          <v-layout
            :key="group"
            mb-2
            row
            style="border: 1px solid #ccc;"
            v-for="group in groups"
          >
            <v-flex style="margin:auto" text-md-center title xs1>{{
              group
            }}</v-flex>
            <v-flex xs11>
              <v-layout
                :key="index"
                row
                v-for="(module, index) in moduleOfGroup(group)"
                wrap
              >
                <v-flex xs2>
                  <v-checkbox
                    :indeterminate="checkedStatus(module.children) === 1"
                    :input-value="checkedStatus(module.children) === 2"
                    :label="module.name"
                    @click.stop="checkAll(module.children)"
                    class="subheading font-weight-black"
                  />
                </v-flex>
                <v-flex xs10>
                  <v-checkbox
                    :key="index"
                    :label="funcs.name"
                    class="d-inline-flex mr-3"
                    v-for="(funcs, index) in module.children"
                    v-model="funcs.checked"
                  />
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-form>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      valid: true,
      roles: [],
      functions: [],
      groups: [],
      selectedItems: [],
      selected: [],
      form: {
        roleCode: null,
        roleName: null,
      },
      errors: {
        ROLE_PERMISSION_CAN_NOT_MODIFY:
          '当該ユーザーの利用権限はロックされており、編集できません。',
      },
    }
  },
  methods: {
    functionOfModule() {},
    moduleOfGroup(group) {
      return this.functions.filter(
        (f) => f.desc && !f.desc.localeCompare(group)
      )
    },
    loadRoles() {
      return this.$http.get(`/auth-service/auth/get-role-list`).then((res) => {
        if (res.data.success) {
          var role = res.data.data.data.find(
            (d) => d.roleId === this.$route.query.id
          )
          if (role) {
            this.form = { ...role }
          }
          return res.data.data.data
        } else {
          return []
        }
      })
    },
    loadFunctionsByRoleId() {
      return this.$http
        .get(
          `/auth-service/auth/get-role-functions?roleId=${this.$route.query.id}`
        )
        .then((res) => {
          if (res.data.success) {
            res.data.data
            this.functions = res.data.data

            this.groups = [
              ...new Set(
                this.functions
                  .sort((a, b) => {
                    return a.functionId.localeCompare(b.functionId)
                  })
                  .map((m) => m.desc)
              ),
            ]
            return res.data.data
          } else {
            return []
          }
        })
    },
    clear() {
      this.selected = []
      this.selectedItems = []
      this.groups = []
      this.modules = []
      this.functions = []
      this.roleFunction = []
    },
    load() {
      this.clear()
      this.loadRoles().then(() => {
        this.loadFunctionsByRoleId()
      })
    },
    save() {
      console.log(
        this.functions
          .map((f) => f.children)
          .flat()
          .filter((c) => c.checked)
          .map((c) => c.functionId)
      )
      var parentFunctions = this.functions
        .map((f) => f.children)
        .flat()
        .filter((c) => c.checked)
        .map((c) => c.parentFunctionId)
      var functions = this.functions
        .map((f) => f.children)
        .flat()
        .filter((c) => c.checked)
        .map((c) => c.functionId)
      this.$http
        .put(`/auth-service/auth/update-role-functions`, {
          roleId: this.form.roleId,
          functions: [...parentFunctions, ...functions],
        })
        .then((res) => {
          this.$message('', '権限設定を保存できました。')
          this.load()
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    selectedFunctionsOfModuleId(module_id) {
      return this.functions
        .filter(
          (f) =>
            f.module_id === module_id &&
            this.selectedItems.includes(f.function_id)
        )
        .map((f) => f.function_id)
    },
    checkedStatus(children) {
      if (
        children &&
        children.length > 0 &&
        children.filter((c) => !c.checked).length === 0
      ) {
        return 2 //该模块下选中的function数量等于该模块下全部Function的数量,则返回2
      }
      if (
        children &&
        children.length > 0 &&
        children.filter((c) => !!c.checked).length === 0
      ) {
        return 0 //该模块下一个都没有选中
      }
      return 1 //至少有一个该模块下选中的Function
    },
    checkAll(children) {
      if (this.checkedStatus(children) === 0) {
        //如果该模块下没有一个选中的Function，则加入全部该模块的function
        children.forEach((c) => {
          c.checked = true
        })
      } else {
        //如果至少有一个该模块下的Function,则在选择项中清空所有该模块的Function
        children.forEach((c) => {
          c.checked = false
        })
      }
    },
  },
  mounted() {
    this.load()
  },
}
</script>
